import { createSlice } from '@reduxjs/toolkit';
import { findGPLXPracticalExamAPI, getGPLXPracticalExamByIdAPI } from '../../../service/gplx/gplx.practicalExam.service';
// utils

const initialState = {
  isLoading: false,
  error: null,
  totalElements: 0,
  totalPages: 0,
  numberOfElements: 0,
  practicalExams: [],
  practicalExam: null,
  search: {
    page: 0,
    size: 10,
    value: '',
    orders: [
      {
        order: "desc",
        property: 'createdAt'
      }
    ]
  }
};

const slice = createSlice({
  name: 'gplxPracticalExam',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setPracticalExams(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.practicalExams = response.data;
      state.totalElements = response.totalElements;
      state.totalPages = response.totalPages;
      state.numberOfElements = response.numberOfElements;
    },
    setPracticalExam(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.practicalExam = response.data;
    },
    setGPLXPracticalExamSearch(state, action) {
      state.isLoading = false;
      state.search = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;
// Actions
export const { setGPLXPracticalExamSearch } = slice.actions;
// ----------------------------------------------------------------------

export function getGPLXPracticalExams() {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    // read state from rootReducer
    const { practicalExam } = getState();

    const resp = await findGPLXPracticalExamAPI({ ...practicalExam.search, value: `%${practicalExam.search.value}%` });

    if (resp.code === '200')
      dispatch(slice.actions.setPracticalExams(resp));
    else
      dispatch(slice.actions.hasError(resp));
  };
}

export function getGPLXPracticalExam(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const resp = await getGPLXPracticalExamByIdAPI(id);
    if (resp.code === '200')
      dispatch(slice.actions.setPracticalExam(resp));
    else
      dispatch(slice.actions.hasError(resp));
  };
}